import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  SimpleChanges,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

import { TranslatePipe } from '@ngx-translate/core';
import { PinchZoomComponent } from '@meddv/ngx-pinch-zoom';
import { SafeUrlPipe } from '../../_pipes/safe-url.pipe';

@Component({
    selector: 'app-image-lightbox',
        standalone: true,
templateUrl: './image-lightbox.component.html',
    styleUrls: ['./image-lightbox.component.scss'],
    imports: [MatIconButton, MatIcon, PinchZoomComponent, SafeUrlPipe]
})
export class ImageLightboxComponent {
  safeSrc!: SafeResourceUrl;
  showZoom: boolean = true;

  constructor(
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA)
    public data: { src: string; images: any[]; currentIndex: number },
    private dialogRef: MatDialogRef<ImageLightboxComponent>,
    private cdr: ChangeDetectorRef,
    private elementRef: ElementRef
  ) {
    this.updateSafeSrc();
    this.dialogRef.backdropClick().subscribe(() => {
      this.closeDialog();
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) {
      this.updateSafeSrc();
      this.resetZoom();
    }
  }
  // Handle click events on the container
  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    // Check if the click was directly on the lightbox container (backdrop area)
    // and not on its children (image, buttons, etc.)
    if (
      event.target ===
      this.elementRef.nativeElement.querySelector('.lightbox-container')
    ) {
      this.closeDialog();
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  prevImage(): void {
    this.data.currentIndex =
      this.data.currentIndex === 0
        ? this.data.images.length - 1
        : this.data.currentIndex - 1;
    this.data.src = this.data.images[this.data.currentIndex]?.src;
    this.updateSafeSrc();
    this.resetZoom();
  }

  nextImage(): void {
    this.data.currentIndex =
      this.data.currentIndex === this.data.images.length - 1
        ? 0
        : this.data.currentIndex + 1;
    this.data.src = this.data.images[this.data.currentIndex]?.src;
    this.updateSafeSrc();
    this.resetZoom();
  }
  sanitizeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  private updateSafeSrc(): void {
    if (this.data.images[this.data.currentIndex]?.type === 'video') {
      this.safeSrc = this.data.src;
    }
  }

  resetZoom(): void {
    this.showZoom = false;
    this.cdr.detectChanges();
    this.showZoom = true;
    this.cdr.detectChanges();
  }
}
